// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3bti9","itemTitle":"ClientEmergencyInfo_itemTitle__2y9Y1","itemText":"ClientEmergencyInfo_itemText__3A8Xe"};